import axios from "axios";
import config from "../../config.json";

export async function fetchBackofficeSidebarSettings() {
  const token = localStorage.getItem("tokenLogin");
  if (!token) {
    throw new Error("Authentication token is missing.");
  }

  const response = await axios.get(
    `${config.dev}/restau/backoffice-sidebar`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  return response.data?.data || { disabledBackofficeMenuKeys: [] };
}
